import React, { FC } from 'react';
import { CircularProgress } from 'drift-ui';
import cx from 'classnames';
import styles from './submitting.module.scss';
import { useTranslation } from 'react-i18next';
import { DO_APPLICATION_TYPE } from 'client-experience-toolbox';

interface SubmittingComponentProps {
  type: DO_APPLICATION_TYPE;
  postSubmissionStep?: number;
}

const SubmittingComponent: FC<SubmittingComponentProps> = ({ type, postSubmissionStep }) => {
  const { t } = useTranslation();
  const isBanking = type === DO_APPLICATION_TYPE.BANKING;

  return (
    <div className={cx(styles.submitting_container, isBanking ? styles.submitting_modal : styles.submitting_inline)}>
      {isBanking ? (
        <>
          <span className={styles.spinner_text}>
            {t('digital_onboarding.banking.post_submission_screens.submitting_step_of_n', {
              currentStep: postSubmissionStep ?? 1,
              totalSteps: 3,
            })}
          </span>
          <CircularProgress color="primary" size={32} thickness={4} />
        </>
      ) : (
        <>
          <CircularProgress color="success" size={157} thickness={2} />
          <span className={styles.spinner_text}>{t('submitting_your_application')}</span>
        </>
      )}
    </div>
  );
};

export default SubmittingComponent;
